// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1276bd44","453":"d855a71b","667":"ebc8d7d9"}[chunkId] + ".chunk.js";
};